import { Professional } from "@/@types/esus/Professional";
import { esusApi } from "../api";

type GetProfessionalsParams = {
	uf: string;
	ibgeCode: string;
	cnes?: string;
};

export async function getProfessionals({ uf, ibgeCode, ...params }: GetProfessionalsParams) {
	const response = await esusApi.get<Professional[]>(
		`/uf/${uf}/city/${ibgeCode}/professional/getprofessionals`,
		params
	);
	return response.data || [];
}
